'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useSettings } from '@/hooks/use-settings';

// Local setting, not tied to any workspace/user DB row. Mirrors `debug` onto
// <html data-debug> so src/css/variants.css's `debug:` variant and
// src/css/debug.css's outline rule can both key off it.
// No visual overlay yet (pinia's center crosshair was for its map pin editor,
// which doesn't apply here) — stuffbox's own debug affordance is TBD.
export const DebugProvider = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  const [debug] = useSettings("debug", false);
  let t1;
  let t2;
  if ($[0] !== debug) {
    t1 = () => {
      document.documentElement.setAttribute("data-debug", debug);
    };
    t2 = [debug];
    $[0] = debug;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return children;
};